export default __webpack_public_path__ + "static/media/eventlocation-requests.6fe4c81d.png";